// removed by extract-text-webpack-plugin
module.exports = {"button":"button--aa792","root":"root--2238c","wideModeRoot":"wideModeRoot--1a9f9","listItemText":"listItemText--f2260","icon":"icon--88933"};